angular
    .module('cvsApp').directive('ccvalid', function() {
    return {
        restrict: 'A',
        link: function(scope, elem, attrs) {
            scope.card_info = {};

            var __indexOf = [].indexOf || function(item) {
                    for (var i = 0, l = this.length; i < l; i++) {
                        if (i in this && this[i] === item) return i;
                    }
                    return -1;
                };
            var model = attrs.ngModel;
            var options = {};

            var card, card_type, card_types, get_card_type, is_valid_length, is_valid_luhn, normalize, validate, validate_number, _i, _len, _ref;
            card_types = [{
                name: 'amex',
                pattern: /^3[47]/,
                valid_length: [15]
            }, 
            {
                name: 'diners_club_carte_blanche',
                pattern: /^30[0-5]/,
                valid_length: [14]
            }, {
                name: 'diners_club_international',
                pattern: /3(?:0[0-5]|[68][0-9])[0-9]{11}/,
                valid_length: [14, 16]
            },  
            {
                name: 'jcb_discover',
                pattern:  /^3(0(8[8-9][0-9]|9[0-4][0-9]|9[6-9][0-9])|1(0[0-2][0-9])|1(1[2-9][0-9]|20[0-9])|15[8-9][0-9]|3(3[7-9][0-9]|4[0-9][0-9]))/,   
                valid_length: [16]
            },
            {
                name: 'jcb',
                pattern: /^35(2[89]|[3-8][0-9])/,   
                valid_length: [16]
            },             
            {
                name: 'laser',
                pattern: /^(6304|670[69]|6771)/,
                valid_length: [16, 17, 18, 19]
            }, {
                name: 'visa_electron',
                pattern: /^(4026|417500|4508|4844|491(3|7))/,
                valid_length: [16]
            }, {
                name: 'visa',
                pattern: /^4/,
                valid_length: [16]
            }, {
                name: 'mastercard',
                pattern: /^(5[1-5]|2[2-7])/,
                valid_length: [16]
            }, {
                name: 'maestro',
                pattern: /^(5018|5020|5038|6304|6759|676[1-3])/,
                valid_length: [12, 13, 14, 15, 16, 17, 18, 19]
            }, {
                name: 'discover',
                pattern: /^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)/,
                valid_length: [16]                
            }, {
                name: 'cup_discover',
                pattern: /^81([0-6][0-9]|7[0-1])/,
                valid_length: [16]
            }
        ];

            /*if (options == null) {
                options = {};
            }*/
            if (options.accept == null) {
                options.accept = (function() {
                    var _i, _len, _results;
                    _results = [];
                    for (_i = 0, _len = card_types.length; _i < _len; _i++) {
                        card = card_types[_i];
                        _results.push(card.name);
                    }
                    return _results;
                })();
            }
            _ref = options.accept;

            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                card_type = _ref[_i];
                if (__indexOf.call((function() {
                        var _j, _len1, _results;
                        _results = [];
                        for (_j = 0, _len1 = card_types.length; _j < _len1; _j++) {
                            card = card_types[_j];
                            _results.push(card.name);
                        }
                        return _results;
                    })(), card_type) < 0) {
                    throw "Credit card type '" + card_type + "' is not supported";
                }
            };

            function get_card_type(number) {
                var _j, _len1, _ref1;
                _ref1 = (function() {
                    var _k, _len1, _ref1, _results;
                    _results = [];
                    for (_k = 0, _len1 = card_types.length; _k < _len1; _k++) {
                        card = card_types[_k];
                        if (_ref1 = card.name, __indexOf.call(options.accept, _ref1) >= 0) {
                            _results.push(card);
                        }
                    }
                    return _results;
                })();
                for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
                    card_type = _ref1[_j];
                    if (number.match(card_type.pattern)) {
                        return card_type;
                    }
                }
                return null;
            };

            function is_valid_luhn(number) {
                var digit, n, sum, _j, _len1, _ref1;
                sum = 0;
                _ref1 = number.split('').reverse();
                for (n = _j = 0, _len1 = _ref1.length; _j < _len1; n = ++_j) {
                    digit = _ref1[n];
                    digit = +digit;
                    if (n % 2) {
                        digit *= 2;
                        if (digit < 10) {
                            sum += digit;
                        } else {
                            sum += digit - 9;
                        }
                    } else {
                        sum += digit;
                    }
                }
                return sum % 10 === 0;
            };

            function is_valid_length(number, card_type) {
                var _ref1;
                return _ref1 = number.length, __indexOf.call(card_type.valid_length, _ref1) >= 0;
            };

            function validate_number(num) {
           
                var number = normalize(num);
                var length_valid, luhn_valid;
                card_type = get_card_type(number);
                luhn_valid = false;
                length_valid = false;
                if (card_type != null) {
                    luhn_valid = is_valid_luhn(number);
                    length_valid = is_valid_length(number, card_type);
                }

                scope.card_info = {
                    card_type: card_type,
                    valid: luhn_valid && length_valid,
                    luhn_valid: luhn_valid,
                    length_valid: length_valid
                };
              
                scope.validateCardNumber(scope.card_info);
                //scope.hideCardNumber(scope.card_info);

                /**SPEC-1847: highlight input content*/
                elem.bind('click', function () {
                    elem.select();
                })

                /**SPEC-1847: prevent from clipboard cut copy paste */
                function preventCCP(scope, elem){
                    elem.on('cut copy paste', function (event) {
                    event.preventDefault();
                    })
                };

            };//end link function

            function normalize(number) {
                return number.replace(/[ -]/g, '');
            };

            scope.$watch(model, function(value) {
                if (value !== undefined && scope.accountDetails.transactionMode === 'ADD'){
                    
                    validate_number(value);
                }
                
            });

        }
    };
});